import { ListItem } from "../../../../core/services/BaseService";

export enum SpcSteps {
    ServiceType = 'service-type',
    AboutEstimate = 'about-estimate',
    EnterDetails = 'enter-details',
    Summary = 'estimate-summary',
    Estimate = 'estimate-final',
}

export interface SpcStepStatuses {
    serviceType?: string;
    aboutEstimate?: string;
    enterDetails: string;
    summary?: string;
    estimate?: string;
}

export interface SpcSubmissionModel {
    submissionId?: number;
    submissionDate?: Date;
    lovSubmissionStatusId?: number
    submissionStatusDesc?: string;
    submissionType?: string;
}

export interface SpcLovModel {
    serviceTypeListItems?:SpcTypeModel[];
    employerListItems?: ListItem[],
    membershipTierListItems?:ListItem[],
    compensationFrequencyListItems?:ListItem[],
}

export interface SpcModel {
    submissionId: number;
    submissionStatusId: number;
    spcTypeId?:number;
    spcAck?:string;
    estimateDetails?: EstimateDetailsModel[],
    finalEstimate?: FinalEstimateModel,
    newEstimateStatus?:boolean;
}

export interface SpcTypeModel {
    id: number;
    name?: string;
    description?: string;
    descriptionDetail?:string;
    selected?:boolean;
}

export interface EstimateDetailsModel {
    memberId?:string;
    spcTypeSubId:number;
    spcTypeId?:number;
    spcReqId?: number;
    mbrEmployer?:string;
    // mbrEmployerDesc?:string;
    mbrTierId?:number;
    mbrEntryDate?: string & Date | null;//For Temp Call
    startDate?: string & Date | null;
    endDate?:string & Date | null;
    estSvcHours?:number;
    estSvcSplitHours?:number | null;
    fiscalYearLabel1?:string;
    fiscalYearLabel2?:string | null;
    estmComp?:number;
    comFreqId?:number;
    withdrawDate?: string & Date | null;//For Redeposit
    withdrawAmount?:number;
    splitSegment?:boolean;
}

export interface LeaveSegmentModel {
    segment1FiscalYear?:string;
    segment1StartDate?: string & Date | null;
    segment1EndDate?:string & Date | null;
    segment1EstSvcHours?:number;
    segment2FiscalYear?:string;
    segment2StartDate?: string & Date | null;
    segment2EndDate?:string & Date | null;
    segment2EstSvcHours?:number;
}

export interface FinalEstimateModel {
    purchaseEstimate: number;
    spcTypeSubId?: string;
    estimateBreakdowns?: FinalEstimateBreakdownModel[];
}

export interface FinalEstimateBreakdownModel {
    spcReqId?: number;
    spcTypeId?:number;
    estimate?: number;
    employer?: string;
    membershipTier?: string;
    mbrEntryDate?: Date;
    leavePeriodFrom?: Date;
    leavePeriodTo?: Date;
    estimatedHoursOfLeave?:number;
    compensationUsed?:number;
    compensationFrequency?:string;
    hourlyPay?:number;
    withdrawDate?: Date;//For Redeposit
    withdrawAmount?:number;
    leaveSegments?:LeaveSegmentModel[];
}

export interface LeaveSegmentModel {
    startDate?: Date;
    endDate?: Date;
    hours?: number;
    fiscalYear?: string;
    contributionRate?: number;
    compoundInterestFactor?:number;
    hourlyPay?:number;
    cost?:number;
}

export interface SavedEstimatesModel {
    spcTypeSubId?: number;
    createDate?: Date;
    spcTypeId?:number;
    typeOfServiceCredit?: string;
    startDate?: Date;
    endDate?: Date;
    amount?:number;
    spcRequestCount?:number
}

export interface CompareDateModel {
    fromDate?: string;
    toDate?: string;
    spcTypeId?:number;
    mbrEntryDate?:string;
}

export interface SpcUrlModel {
    url?: string,
}